export const ID = 'USER_LIST';

export const SEARCH_USERS = `${ID}/SEARCH_USERS`;
